import BaseService from './base'

export default class DisplayPeriodService extends BaseService {
  static resource() {
    return 'api/v1/display_periods'
  }
}
